import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import {
  faxNumberSubmittedPortMetric,
  faxReceivedMetric,
  missedCallSmsMetric,
  reviewsSettingsMetric,
} from '../../handoff-metrics/metrics/premium-features';
import { wiePayerConnectionMetric } from '../../handoff-metrics/metrics/wie-payer';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

const shouldSkipAdditionalFeatures = (ctx: UnifyMetricEvalContext) =>
  !ctx.officeConfigurations?.hasPremiumFeatures;

export const reviewsEnabledMetricDef: UnifyMetricDefinition = {
  id: 'reviews_enabled',
  name: 'Reviews Enabled',
  sectionName: 'Additional Features',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipAdditionalFeatures(ctx) ||
    !isCustomizationFeatureEnabled('Reviews Home Icon', ctx.features),
  criteria: [adaptHandoffMetric(reviewsSettingsMetric)],
};

export const missedCallSmsMetricDef: UnifyMetricDefinition = {
  id: 'missed_call_sms',
  name: 'Missed Call SMS',
  sectionName: 'Additional Features',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipAdditionalFeatures(ctx) ||
    Boolean(ctx.officeConfigurations?.isSoftwareOnly) ||
    !isCustomizationFeatureEnabled('Missed call text', ctx.features),
  criteria: [adaptHandoffMetric(missedCallSmsMetric)],
};

export const faxMetricDef: UnifyMetricDefinition = {
  id: 'fax',
  name: 'Fax',
  sectionName: 'Additional Features',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipAdditionalFeatures(ctx) ||
    !isCustomizationFeatureEnabled('Fax', ctx.features),
  criteria: [
    adaptHandoffMetric(faxNumberSubmittedPortMetric),
    adaptHandoffMetric(faxReceivedMetric),
  ],
};

export const connectPayersMetricDef: UnifyMetricDefinition = {
  id: 'connect_payers',
  name: 'Connect Payers',
  sectionName: 'Additional Features',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipAdditionalFeatures(ctx) ||
    !isCustomizationFeatureEnabled('Enhanced Insurance Verification', ctx.features),
  criteria: [adaptHandoffMetric(wiePayerConnectionMetric)],
};
